import { daysUntil } from '@/utils/format';
import type { PipelineRunReadDto } from '@/types/api';

export function WorkspaceCleanupStatus({
  run,
  now,
  placeholder
}: {
  run: Pick<PipelineRunReadDto, 'workspace_reclaimed_at' | 'workspace_cleanup_due_at'>;
  now?: number;
  placeholder?: JSX.Element;
}): JSX.Element | null {
  const nothing = placeholder ?? null;

  if (run.workspace_reclaimed_at) return <CleanedLabel />;

  const due = run.workspace_cleanup_due_at ?? null;
  if (!due) return nothing;

  const until = daysUntil(due, now);

  if (until.kind === 'unknown') return nothing;

  if (until.kind === 'passed') return <CleanedLabel />;

  return (
    <span data-testid="workspace-cleanup-due">
      workspace cleanup in{' '}
      <span className="text-text-dim">
        {until.days} {until.days === 1 ? 'day' : 'days'}
      </span>
    </span>
  );
}

function CleanedLabel(): JSX.Element {
  return (
    <span data-testid="workspace-cleaned">
      workspace · <span className="text-text-dim">cleaned</span>
    </span>
  );
}
